import React from "react";
import { Container } from "reactstrap";
import termsImg1 from "../../assets/img/termsImg1.png";
import termsImg2 from "../../assets/img/termsImg2.png";
import { useSelector } from "react-redux";

const TermsAndConditions = () => {
    const { user } = useSelector((state) => state.authUser);
    return (
        <Container className="py-md-5">
            <p
                className="text-center py-3"
                style={{ textDecoration: "underline" }}
            >
                <strong>
                    {" "}
                    Athlete - INSTRUCTIONS AND TEXT/PHOTO/QR SUBMISSION FORM
                    ATHLETE: TO MAKE YOUR MEMENTO – You will Submit Photos,
                    Videos, QRs, and text (see MEMENTO Sample bottom of form):
                </strong>
            </p>
            <div className="mx-md-5">
                {user?.role == "fan" ? (
                    <>
                        <p>
                            Fan:
                            <strong> {user?.name}</strong>, FHP ID#{" "}
                            <strong>{user?.id}</strong>.
                        </p>
                    </>
                ) : (
                    <p>
                        Athlete:
                        <strong>
                            {" "}
                            {user?.first_name} {user?.last_name}
                        </strong>
                        , FHP ID# <strong>{user?.athleteID}</strong>.
                    </p>
                )}

                <p>
                    Click attestation, list name of person who is doing the
                    submission.{" "}
                </p>
                <p>
                    <input type="checkbox" required></input> I attest submitted
                    materials are personal photos/videos taken by me (or by the
                    athlete/friends) and are fully available to FHP to use in
                    constructing mementos without need for further permission or
                    license from anyone.
                </p>
                <p>
                    {user?.role == "fan" ? (
                        <>
                            Name submitting: <strong> {user?.name}</strong>{" "}
                        </>
                    ) : (
                        <>
                            Name submitting:{" "}
                            <strong>
                                {" "}
                                {user?.first_name} {user?.last_name}
                            </strong>{" "}
                        </>
                    )}
                    Email: <strong> {user?.email}</strong>
                </p>
            </div>
            <div className="mx-md-5">
                <p style={{ textDecoration: "underline" }}>
                    <strong>PHOTOS – SPECS:</strong>
                </p>
                <p>
                    Photo/video content: BE SURE CONTENT COMPLIES WITH YOUR
                    SCHOOL’S NIL REGS.
                </p>
                <p>Still Image photo: Minimum 10 MP</p>
                <p>
                    Each athlete allowed to fill up to three memento templates
                    (can request more if you have sales).
                </p>
                <p>Photos submitted: Minimum 3, Maximum 9.</p>
                <p>
                    Use the upload tool to submit your photos. Here’s how it
                    works: click the photo icon in the first memento (icon
                    labeled PX1) and you will see submit instructions. Submit
                    photo for first memento.{" "}
                </p>
            </div>
            <div className="mx-md-5">
                <p style={{ textDecoration: "underline" }}>
                    <strong>VIDEOS – SPECS:</strong>
                </p>
                <p>
                    Photo/video content: BE SURE CONTENT COMPLIES WITH YOUR
                    SCHOOL’S NIL REGS.
                </p>
                <p>
                    Video clips: EACH LENGTH - 30 secs or up to 15 minutes, each
                    uploaded to YouTube. You designate ‘Unlisted’ at YouTube,
                    and you copy URL and make note of contents per each URL
                    (this will help you when you start to input URLs into
                    templates).
                </p>
                <p>
                    Minimum video QRs submitted: 3 (one each QR code per digital
                    element group (DEG) of memento).{" "}
                </p>
                <p>
                    Maximum number of video QRs allowed is number which fills
                    the QR slots in the templates you are filling.
                </p>
                <p>
                    BE SURE THE CONTENT OF THE QR/Video matches the content of
                    the text and photo per want to match in the DEG you are
                    filling. Here is an illustration of the UPLOAD TOOL for you
                    to get acquainted.
                </p>
                <div className="d-flex justify-content-center">
                    <img
                        src={termsImg1}
                        alt="terms and conditions"
                        className="w-75"
                    />
                </div>
                <p>
                    Here’s how it works: Upload each of your videos to YouTube,
                    marking each as UNLISTED. Collect the URL for each video,
                    making a note for yourself as to which content is on which
                    Video/URL. You can use Adobe Express free QR code generator
                    to convert your URLs to static QRs. If you wish to use one
                    or more ‘dynamic QRs’ for your memento, check with
                    QRCodeChimp
                    <a href="https://www.qrcodechimp.com/">
                        https://www.qrcodechimp.com/
                    </a>
                    . Their free plan allows you to prepare 10 Dynamic QRs free
                    of charge.
                </p>
                <p>
                    Once you have your QRs and your content-matching photos, you
                    should select the text words you will use to match in each
                    DEG. Before you upload a QR, scan it with your cell phone to
                    be sure it is working and to double-check the contents to
                    make sure you can match it to DEG group.
                </p>
                <p>
                    Now you are ready to upload your text words, photos, and QRs
                    to the correct memento DEG position in each template. For
                    example, for the first memento template DEG (left side DEG),
                    click the text button and you can type in your choice of
                    words. Then click the photo button, and you will be able to
                    upload the photo that matches those words. Then click the
                    left side ‘X1QR1’ and you will be able to upload the first
                    QR which has linked video content matching that photo and
                    text. Proceed in similar manner for the other DEGs in the
                    templates you wish to fill.
                </p>
                <p>
                    NOTE: A digital element group (DEG) can have up to 4 QRs
                    associated to a photo within the digital element group (see
                    sample’s middle DEG called ‘SISTER SLAM’).
                </p>
                <p>Clickable text/photo/QR Upload tool:</p>
            </div>
            <div className="mx-md-5">
                <p style={{ textDecoration: "underline" }}>
                    <strong>SAMPLE MEMENTO (see below):</strong>
                </p>

                <div className="d-flex justify-content-center">
                    <img
                        src={termsImg2}
                        alt="term and conditions"
                        className="w-75"
                    />
                </div>
            </div>
        </Container>
    );
};

export default TermsAndConditions;
